import { useState } from "react";

export default function EventCreatedModal({ eventId, onClose }) {
  const url = `${window.location.origin}${window.location.pathname}#/event/${eventId}`;
  const [copied, setCopied] = useState(false);

  function copy() {
    navigator.clipboard.writeText(url);
    setCopied(true);
    setTimeout(() => setCopied(false), 2500);
  }

  return (
    <div style={{
      position: "fixed", inset: 0, background: "rgba(0,0,0,0.9)",
      display: "flex", alignItems: "center", justifyContent: "center",
      zIndex: 200, padding: "0 20px",
    }}>
      <div className="card" style={{ maxWidth: 460, width: "100%", padding: "36px 28px", textAlign: "center" }}>
        <div style={{ fontSize: 40, marginBottom: 16 }}>🎉</div>
        <h2 style={{ fontFamily: "var(--font-display)", fontSize: 26, color: "#fff", letterSpacing: 2, marginBottom: 8 }}>
          ¡EVENTO CREADO!
        </h2>
        <p style={{ fontSize: 13, color: "#555", marginBottom: 24, lineHeight: 1.6 }}>
          Comparte este link con los participantes.
        </p>
        <div style={{ display: "flex", gap: 8, marginBottom: 20 }}>
          <input
            className="input"
            value={url}
            readOnly
            style={{ flex: 1, fontSize: 11, color: "#777" }}
            onFocus={e => e.target.select()}
          />
          <button className="btn-primary" onClick={copy} style={{ flexShrink: 0, minWidth: 84 }}>
            {copied ? "✓ Copiado" : "Copiar"}
          </button>
        </div>
        <button className="btn-ghost" style={{ width: "100%", padding: 10 }} onClick={onClose}>
          Ir al panel
        </button>
      </div>
    </div>
  );
}
